import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { siteConfig } from '../constant/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

const SetupSuccess = () => {
    const { t } = useLanguage();

    return (
        <div
            className="flex flex-col items-center justify-center min-h-screen px-4 text-white text-center"
            style={{ backgroundColor: siteConfig.brandColors.secondary }}
        >
            {/* Animated Check Icon */}
            <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <CheckCircle className="w-20 h-20 sm:w-24 sm:h-24 text-white animate-bounce" />
            </motion.div>

            {/* Success Message */}
            <motion.h1
                className="mt-6 text-3xl font-bold sm:text-5xl"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.8 }}
            >
                {t('success.setupDone')}
            </motion.h1>

            {/* Go Home Button */}
            <motion.a
                href={siteConfig.paymentSucceededPageRedirectLink}
                className="mt-6 px-5 py-3 sm:px-6 sm:py-3 bg-white font-semibold rounded-full shadow-lg hover:bg-gray-200 transition"
                style={{ color: siteConfig.brandColors.primary }}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
            >
                {t('common.goHome')}
            </motion.a>
        </div>
    );
};

export default SetupSuccess;
